export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'link' | 'icon';
export type ButtonSize = 'sm' | 'md';

const FOCUS = 'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
const DISABLED = 'disabled:opacity-50 disabled:cursor-not-allowed';
// A boxed label stays on one line; the row around it wraps instead.
const BOX = 'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-sm border font-medium shadow-xs';

const VARIANT: Record<ButtonVariant, string> = {
  primary: `${BOX} border-primary bg-primary text-primary-foreground hover:bg-primary/90 disabled:hover:bg-primary`,
  secondary: `${BOX} border-border bg-card text-card-foreground hover:bg-secondary disabled:hover:bg-card`,
  danger: `${BOX} border-destructive bg-destructive text-white hover:bg-destructive/90 disabled:hover:bg-destructive`,
  link: 'text-left text-primary underline-offset-2 hover:underline disabled:hover:no-underline',
  icon: 'inline-flex items-center justify-center rounded-sm leading-none text-muted-foreground hover:bg-muted hover:text-foreground disabled:hover:bg-transparent disabled:hover:text-muted-foreground',
};

const SIZE: Record<ButtonVariant, Record<ButtonSize | 'default', string>> = {
  primary: { sm: 'px-2 py-1 text-xs', md: 'px-3 py-1.5 text-sm', default: 'px-3 py-1.5 text-sm' },
  secondary: { sm: 'px-2 py-1 text-xs', md: 'px-3 py-1.5 text-sm', default: 'px-3 py-1.5 text-sm' },
  danger: { sm: 'px-2 py-1 text-xs', md: 'px-3 py-1.5 text-sm', default: 'px-3 py-1.5 text-sm' },
  link: { sm: 'text-xs', md: 'text-sm', default: '' },
  icon: { sm: 'p-0.5', md: 'p-1.5', default: 'p-1' },
};

/** Classes for links that must look like shared action buttons. */
export function buttonClass(variant: ButtonVariant, size?: ButtonSize): string {
  return [VARIANT[variant], SIZE[variant][size ?? 'default'], 'cursor-pointer', FOCUS, DISABLED].filter(Boolean).join(' ');
}
